import {useMatchChain, useMatchWalletAssetList, useMatchWalletAssets} from "hooks";
import AlphaAvatar from "../AlphaAvatar";
import {NumberFormatter} from "../../utils";
import {useMatchWalletAssetsProps, WalletAssetMergeType} from "../../types";

export default function WalletAsset({
                                        onAssetClick,
                                        matchWalletAssetsOptions
                                    }: {
    onAssetClick?: (asset: WalletAssetMergeType) => () => void
    matchWalletAssetsOptions?: useMatchWalletAssetsProps
}) {
    const walletAssets = useMatchWalletAssets(matchWalletAssetsOptions)
    const matchWalletAssetList = useMatchWalletAssetList({
        list: walletAssets.mergedAssets
    })
    const {list} = useMatchChain()
    return (
        <div className={"matchid-wallet-asset-list"}>
            {
                matchWalletAssetList.list.map((n, index) => {
                    const clickFunc = onAssetClick && onAssetClick(n)
                    const chain = list?.find((m) => m.id.toString() === n.chain_id)
                    const getFooterColor = () => {
                        if (!n.price_change_24h) {
                            return ''
                        }
                        if (n.price_change_24h > 0) {
                            return 'matchid-wallet-asset-up'
                        }
                        if (n.price_change_24h < 0) {
                            return 'matchid-wallet-asset-down'
                        }
                        return ''
                    }
                    return <div className={`matchid-wallet-asset-item`} onClick={clickFunc} style={{
                        cursor: clickFunc ? 'pointer' : 'default'
                    }} key={index}>
                        <div className={"matchid-wallet-asset-logo"} title={n.symbol || n.name || ''}>
                            {n.icon ? <img src={n.icon} alt={n.symbol} className={`matchid-wallet-asset-icon`}/> :
                                <AlphaAvatar className={`matchid-wallet-asset-icon`} size={40}
                                             name={n.symbol || n.name || ''}/>}
                            {chain?.iconUrl &&
                                <img src={chain.iconUrl} alt={chain.name} className={`matchid-wallet-asset-chain`}/>}
                        </div>
                        <div className={`matchid-wallet-asset-info`}>
                            <div className={`matchid-wallet-asset-name`}>{n.symbol}</div>
                            {
                                ('price' in n) && <div className={`matchid-wallet-asset-content`}>
                                    <div className={"matchid-wallet-asset-price"}><NumberFormatter value={n.price}
                                                                                                   prefix={"$ "}
                                                                                                   tFixNum={2}/></div>

                                    <div className={"matchid-wallet-asset-value"}><NumberFormatter value={n.value}
                                                                                                   prefix={"$ "}
                                                                                                   tFixNum={2}/></div>
                                </div>
                            }

                            <div className={`matchid-wallet-asset-footer`}>
                                <div className={`matchid-wallet-asset-balance`}><NumberFormatter value={n.balance}
                                                                                                 tFixNum={3}/></div>
                                {'price_change_24h' in n &&
                                    <div className={`matchid-wallet-asset-change ${getFooterColor()}`}><NumberFormatter
                                        prefix={`${(n?.price_change_24h || 0) < 0 ? '-' : '+'} `}
                                        value={Math.abs(n.price_change_24h || 0)} suffix={"%"} tFixNum={3}/></div>}

                            </div>
                        </div>
                    </div>
                })
            }
        </div>
    )
}